<template>
    <div>
        <div class="p_title container bottomline mt30">
            <div class="titlebox fleft mt20">
                <h5>关于我们</h5>
                <p>About Us</p>
            </div>
            <ul class="titlemenu fright mt50">
                <li><router-link :to="{path:'/info',query:{pid:pidjianjie}}">公司简介</router-link></li>
                <li><router-link :to="{path:'/info',query:{pid:pidwenhua}}">企业文化</router-link></li>
                <li class="active"><router-link :to="{path:'/partner',query:{pid:pidpartner}}">合作伙伴</router-link></li>
                <li><router-link :to="{path:'/info',query:{pid:pidlianxi}}">联系方式</router-link></li>
            </ul>
        </div>
        <div class="p_body container">
            <ul class="p_body_logo mt30">
                <li v-for="(item) in tableData" :key="item.id">
                    <a :href="item.linkUrl" target="_blank">
                        <img :src="imgbaseurl+item.imgUrl" :alt="item.altWord">
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>


<script>

import configration from '../tools/js/enumconfig'

export default {
    data(){
        return {
            parameters:{
                parentId:configration.config.enum.pidpartner
            },
            tableData:[],
            pid:'',
            showtitle:'合作伙伴',
            imgbaseurl : this.$baseURL.fileurl,
            pidjianjie:configration.config.enum.pidjianjie,
            pidwenhua:configration.config.enum.pidwenhua,
            pidlianxi:configration.config.enum.pidlianxi,
            pidpartner:configration.config.enum.pidpartner,


        }
    },

     methods:{

        getList:function(){
            let vm = this;
            vm.parameters.PageSize = vm.pageSize;
            vm.parameters.CurrentPage = vm.curPage;
            vm.$httpi.post('/api/v1/articles/adv/GetAll', vm.parameters)
            .then(function (response) {
                if(response.data.success){
                    vm.tableData = response.data.data;
                }
            });
            
        },

        gotodetail(pid){
            const vm = this;
            vm.$router.push({path:'/info',query:{pid:pid}});
            vm.initpage();
        },
        gotopartner(pid){
            const vm = this;
            vm.$router.push({path:'/partner',query:{pid:pid}});
        },
        initpage(){
            let vm = this;
            //绑定
            vm.getList();
        }
     },
     mounted() {
        let vm = this;
        //console.log(configration);
        //绑定
        vm.getList();
    }
}
</script>
